import React__default, { useState, createElement, Fragment as Fragment$1, forwardRef, useImperativeHandle, useRef, useEffect, useMemo } from 'react';
import { Form, InputGroup, Button, Toast, Spinner, Modal, DropdownButton, ButtonGroup, Dropdown, Tabs, Tab, Accordion, ListGroup, Collapse, Table, FormControl, Row, Col, Container, Card } from 'react-bootstrap';
import { BsFillEyeSlashFill, BsFillEyeFill, BsExclamationTriangleFill } from 'react-icons/bs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import DatePicker, { registerLocale } from 'react-datepicker';
import classNames from 'classnames';
import { AiOutlineFullscreenExit, AiOutlineFullscreen, AiOutlineClose } from 'react-icons/ai';
import SunEditor from 'suneditor-react';
import { useDropzone } from 'react-dropzone';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 } from 'uuid';
import SimpleBarReact from 'simplebar-react';
import { useAsyncDebounce, useTable, useGlobalFilter, useSortBy, usePagination, useRowSelect } from 'react-table';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

var parseValue = function parseValue(newValue, isDecimal) {
  if (!newValue) {
    return newValue;
  }
  if (isDecimal) {
    return parseFloat(newValue);
  }
  return parseInt(newValue);
};
var OcdInputNumber = function OcdInputNumber(props) {
  var _React$useState = useState(function () {
      return parseValue(props.value.toString(), props.isDecimal);
    }),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _onChange = function onChange(e) {
    var newValue = parseValue(e.target.value, props.isDecimal);
    setValue(newValue);
    if (props.onChangeValue) {
      props.onChangeValue(newValue);
    }
  };
  return createElement(Form.Control, {
    type: "number",
    className: props.className ? props.className : "",
    value: value,
    size: props.size ? props.size : "sm",
    disabled: props.disabled == true ? true : false,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  });
};

var styles = {"c-pointer":"_3-v4L","input-group-text-sm":"_1Tr2X","react-datepicker-popper":"_teoHn","focus-item":"_2bz-S"};

var OcdInputPassword = function OcdInputPassword(props) {
  var _React$useState = useState(false),
    showPassword = _React$useState[0],
    setShowPassword = _React$useState[1];
  var _React$useState2 = useState(function () {
      return props.value;
    }),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _onChange = function onChange(e) {
    var newValue = e.target.value;
    setValue(newValue);
    if (props.onChangeValue) {
      props.onChangeValue(newValue);
    }
  };
  return createElement(InputGroup, {
    className: props.className ? props.className : ""
  }, createElement(Form.Control, {
    type: showPassword ? "text" : "password",
    value: value,
    size: props.size ? props.size : "sm",
    disabled: props.disabled == true ? true : false,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  }), createElement(InputGroup.Text, {
    className: styles["c-pointer"],
    onClick: function onClick() {
      setShowPassword(!showPassword);
    }
  }, showPassword ? createElement(BsFillEyeSlashFill, null) : createElement(BsFillEyeFill, null)));
};

var OcdInputText = function OcdInputText(props) {
  var _React$useState = useState(function () {
      return props.value;
    }),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _onChange = function onChange(e) {
    var newValue = e.target.value;
    setValue(newValue);
    if (props.onChangeValue) {
      props.onChangeValue(newValue);
    }
  };
  return createElement(Form.Control, {
    type: "text",
    className: props.className ? props.className : "",
    value: value,
    size: props.size ? props.size : "sm",
    disabled: props.disabled == true ? true : false,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  });
};

var OcdInputTextMix = function OcdInputTextMix(props) {
  var MixTypeComponent = function MixTypeComponent() {
    if (props.mixType == "label") {
      return createElement("span", {
        className: styles["input-group-text" + (!props.size || props.size == "sm" ? "-sm" : "")]
      }, createElement(FontAwesomeIcon, {
        icon: props.mixIcon
      }), "\xA0", props.mixLabel);
    } else if (props.mixType == "button") {
      return createElement(Button, {
        disabled: props.disabled == true ? true : false,
        className: !props.size || props.size == "sm" ? "btn-sm" : "",
        onClick: function onClick() {
          if (props.mixClick) {
            props.mixClick();
          }
        }
      }, createElement(FontAwesomeIcon, {
        icon: props.mixIcon
      }), "\xA0", props.mixLabel);
    }
    return createElement(Fragment$1, null);
  };
  return createElement(InputGroup, {
    className: props.className ? props.className : ""
  }, props.align == "left" && createElement(MixTypeComponent, null), createElement(OcdInputText, {
    value: props.value,
    size: props.size,
    placeholder: props.placeholder,
    disabled: props.disabled,
    onChangeValue: props.onChangeValue
  }), props.align == "right" && createElement(MixTypeComponent, null));
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var sizeSmStyle = {
  dropdownIndicator: function dropdownIndicator(provided) {
    return _extends({}, provided, {
      padding: '4px'
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return _extends({}, provided, {
      padding: '4px'
    });
  }
};
var OcdSelect = function OcdSelect(props) {
  var _React$useState = useState(function () {
      return props.value;
    }),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _onChange = function onChange(newValue) {
    var value = newValue ? newValue.value : newValue;
    setValue(value);
    if (props.onChangeValue) {
      props.onChangeValue(value);
    }
  };
  var getValue = function getValue(value) {
    var options = props.options;
    for (var i = 0; i < options.length; i++) {
      if (options[i].value == value) {
        return options[i];
      }
    }
    return null;
  };
  return createElement(Select, {
    styles: !props.size || props.size ? sizeSmStyle : undefined,
    options: props.options,
    placeholder: props.placeholder,
    className: (props.className ? props.className : "") + " " + styles[!props.size || props.size == "sm" ? "react-select-sm" : ""],
    classNamePrefix: "react-select",
    isClearable: props.clearable,
    isSearchable: props.searchable,
    isDisabled: props.disabled,
    isMulti: props.multiple,
    value: getValue(value),
    onChange: function onChange(newValue) {
      return _onChange(newValue);
    }
  });
};

var OcdTextarea = function OcdTextarea(props) {
  var _React$useState = useState(function () {
      return props.value;
    }),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _onChange = function onChange(e) {
    var newValue = e.target.value;
    setValue(newValue);
    if (props.onChangeValue) {
      props.onChangeValue(newValue);
    }
  };
  return createElement(Form.Control, {
    as: "textarea",
    rows: props.row ? props.row : 5,
    className: props.className ? props.className : "",
    value: value,
    size: props.size ? props.size : "sm",
    disabled: props.disabled == true ? true : false,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  });
};

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'dưới 1 giây',
    other: 'dưới {{count}} giây'
  },
  xSeconds: {
    one: '1 giây',
    other: '{{count}} giây'
  },
  halfAMinute: 'nửa phút',
  lessThanXMinutes: {
    one: 'dưới 1 phút',
    other: 'dưới {{count}} phút'
  },
  xMinutes: {
    one: '1 phút',
    other: '{{count}} phút'
  },
  aboutXHours: {
    one: 'khoảng 1 giờ',
    other: 'khoảng {{count}} giờ'
  },
  xHours: {
    one: '1 giờ',
    other: '{{count}} giờ'
  },
  xDays: {
    one: '1 ngày',
    other: '{{count}} ngày'
  },
  aboutXWeeks: {
    one: 'khoảng 1 tuần',
    other: 'khoảng {{count}} tuần'
  },
  xWeeks: {
    one: '1 tuần',
    other: '{{count}} tuần'
  },
  aboutXMonths: {
    one: 'khoảng 1 tháng',
    other: 'khoảng {{count}} tháng'
  },
  xMonths: {
    one: '1 tháng',
    other: '{{count}} tháng'
  },
  aboutXYears: {
    one: 'khoảng 1 năm',
    other: 'khoảng {{count}} năm'
  },
  xYears: {
    one: '1 năm',
    other: '{{count}} năm'
  },
  overXYears: {
    one: 'hơn 1 năm',
    other: 'hơn {{count}} năm'
  },
  almostXYears: {
    one: 'gần 1 năm',
    other: 'gần {{count}} năm'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' nữa';
    } else {
      return result + ' trước';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: 'dd/MM/y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: '{{date}} {{time}}',
  // ngày 25 tháng 08 năm 2017 23:25
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134

var eraValues = {
  narrow: ['TCN', 'SCN'],
  abbreviated: ['trước CN', 'sau CN'],
  wide: ['trước Công Nguyên', 'sau Công Nguyên']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['Quý 1', 'Quý 2', 'Quý 3', 'Quý 4']
};
var formattingQuarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  // I notice many news outlet use this "quý II/2018"
  wide: ['quý I', 'quý II', 'quý III', 'quý IV']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
  wide: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai']
}; // In Vietnamese date formatting, month number less than 10 expected to have leading zero

var formattingMonthValues = {
  narrow: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  abbreviated: ['thg 1', 'thg 2', 'thg 3', 'thg 4', 'thg 5', 'thg 6', 'thg 7', 'thg 8', 'thg 9', 'thg 10', 'thg 11', 'thg 12'],
  wide: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12']
};
var dayValues = {
  narrow: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  short: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
  abbreviated: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
  wide: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy']
}; // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`

var dayPeriodValues = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'nửa đêm',
    noon: 'tr',
    morning: 'sg',
    afternoon: 'ch',
    evening: 'tối',
    night: 'đêm'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  },
  wide: {
    am: 'SA',
    pm: 'CH',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'nửa đêm',
    noon: 'tr',
    morning: 'sg',
    afternoon: 'ch',
    evening: 'tối',
    night: 'đêm'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  },
  wide: {
    am: 'SA',
    pm: 'CH',
    midnight: 'nửa đêm',
    noon: 'giữa trưa',
    morning: 'vào buổi sáng',
    afternoon: 'vào buổi chiều',
    evening: 'vào buổi tối',
    night: 'vào ban đêm'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;

  if (unit === 'quarter') {
    // many news outlets use "quý I"...
    switch (number) {
      case 1:
        return 'I';

      case 2:
        return 'II';

      case 3:
        return 'III';

      case 4:
        return 'IV';
    }
  } else if (unit === 'day') {
    // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch (number) {
      case 1:
        return 'thứ 2';
      // meaning 2nd day but it's the first day of the week :D

      case 2:
        return 'thứ 3';
      // meaning 3rd day

      case 3:
        return 'thứ 4';
      // meaning 4th day and so on

      case 4:
        return 'thứ 5';

      case 5:
        return 'thứ 6';

      case 6:
        return 'thứ 7';

      case 7:
        return 'chủ nhật';
      // meaning Sunday, there's no 8th day :D
    }
  } else if (unit === 'week') {
    if (number === 1) {
      return 'thứ nhất';
    } else {
      return 'thứ ' + number;
    }
  } else if (unit === 'dayOfYear') {
    if (number === 1) {
      return 'đầu tiên';
    } else {
      return 'thứ ' + number;
    }
  } // there are no different forms of ordinal numbers in Vietnamese


  return String(number);
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns = {
  any: [/^t/i, /^s/i]
};
var matchQuarterPatterns = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
};
var matchMonthPatterns = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns = {
  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
};
var matchDayPatterns = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'wide'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'wide'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */

var locale = {
  code: 'vi',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
    /* First week of new year contains Jan 1st  */

  }
};

registerLocale('vi', locale);
var OcdDatePicker = function OcdDatePicker(props) {
  var _React$useState = useState(props.value),
    date = _React$useState[0],
    setDate = _React$useState[1];
  var CustomInput = forwardRef(function (propsCI, ref) {
    return createElement("div", {
      className: "position-relative"
    }, createElement(Form.Control, {
      ref: ref,
      onClick: propsCI.onClick,
      size: props.size ? props.size : "sm",
      value: propsCI.value,
      className: "ps-4",
      disabled: props.disabled,
      placeholder: props.placeholder,
      onChange: function onChange() {}
    }), createElement(FontAwesomeIcon, {
      icon: "calendar-alt",
      className: "text-primary position-absolute top-50 translate-middle-y ms-2"
    }));
  });
  var _onChange = function onChange(newDate) {
    setDate(newDate);
    if (props.onChangeValue) {
      props.onChangeValue(newDate);
    }
  };
  var selectedDate = function selectedDate(date) {
    if (typeof date == "string") {
      return new Date(date);
    }
    return date;
  };
  return createElement(DatePicker, {
    popperClassName: styles["react-datepicker-popper"],
    className: props.className ? props.className : "",
    locale: "vi",
    selected: selectedDate(date),
    onChange: function onChange(d) {
      return _onChange(d);
    },
    isClearable: true,
    dateFormat: "dd/MM/yyyy",
    customInput: createElement(CustomInput, null)
  });
};

registerLocale('vi', locale);
var OcdTimePicker = function OcdTimePicker(props) {
  var _React$useState = useState(props.value),
    date = _React$useState[0],
    setDate = _React$useState[1];
  var CustomInput = forwardRef(function (propsCI, ref) {
    return createElement("div", {
      className: "position-relative"
    }, createElement(Form.Control, {
      ref: ref,
      onClick: propsCI.onClick,
      size: props.size ? props.size : "sm",
      value: propsCI.value,
      className: "ps-4",
      disabled: props.disabled,
      placeholder: props.placeholder,
      onChange: function onChange() {}
    }), createElement(FontAwesomeIcon, {
      icon: "clock",
      className: "text-primary position-absolute top-50 translate-middle-y ms-2"
    }));
  });
  var _onChange = function onChange(newDate) {
    setDate(newDate);
    if (props.onChangeValue) {
      props.onChangeValue(newDate);
    }
  };
  var selectedDate = function selectedDate(date) {
    if (typeof date == "string") {
      return new Date(date);
    }
    return date;
  };
  return createElement(DatePicker, {
    popperClassName: styles["react-datepicker-popper"],
    className: props.className ? props.className : "",
    locale: "vi",
    selected: selectedDate(date),
    onChange: function onChange(date) {
      return _onChange(date);
    },
    isClearable: true,
    timeIntervals: props.timeIntervals,
    dateFormat: "h:mm aa",
    showTimeSelect: true,
    showTimeSelectOnly: true,
    customInput: createElement(CustomInput, null)
  });
};

registerLocale('vi', locale);
var OcdDateTimePicker = function OcdDateTimePicker(props) {
  var _React$useState = useState(props.value),
    date = _React$useState[0],
    setDate = _React$useState[1];
  var CustomInput = forwardRef(function (propsCI, ref) {
    return createElement("div", {
      className: "position-relative"
    }, createElement(Form.Control, {
      ref: ref,
      onClick: propsCI.onClick,
      size: props.size ? props.size : "sm",
      value: propsCI.value,
      className: "ps-4",
      disabled: props.disabled,
      placeholder: props.placeholder,
      onChange: function onChange() {}
    }), createElement(FontAwesomeIcon, {
      icon: "calendar-alt",
      className: "text-primary position-absolute top-50 translate-middle-y ms-2"
    }));
  });
  var _onChange = function onChange(newDate) {
    setDate(newDate);
    if (props.onChangeValue) {
      props.onChangeValue(newDate);
    }
  };
  var selectedDate = function selectedDate(date) {
    if (typeof date == "string") {
      return new Date(date);
    }
    return date;
  };
  return createElement(DatePicker, {
    popperClassName: styles["react-datepicker-popper"],
    className: props.className ? props.className : "",
    locale: "vi",
    selected: selectedDate(date),
    onChange: function onChange(date) {
      return _onChange(date);
    },
    isClearable: true,
    timeIntervals: props.timeIntervals ? props.timeIntervals : 5,
    dateFormat: "dd/MM/yyyy h:mm aa",
    showTimeSelect: true,
    customInput: createElement(CustomInput, null)
  });
};

var OcdCheckbox = function OcdCheckbox(props) {
  var _React$useState = useState(props.checked),
    checked = _React$useState[0],
    setChecked = _React$useState[1];
  var _onChange = function onChange(e) {
    var checked = e.target.checked;
    setChecked(checked);
    if (props.onChangeChecked) {
      props.onChangeChecked(checked);
    }
  };
  return createElement(Form.Check, {
    type: 'checkbox',
    className: (props.className ? props.className : "") + " mb-0",
    label: props.label,
    checked: checked,
    disabled: props.disabled == true ? true : false,
    inline: props.inline == true ? true : false,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  });
};

var OcdSwitch = function OcdSwitch(props) {
  var _React$useState = useState(props.checked),
    checked = _React$useState[0],
    setChecked = _React$useState[1];
  var _onChange = function onChange(e) {
    var checked = e.target.checked;
    setChecked(checked);
    if (props.onChangeChecked) {
      props.onChangeChecked(checked);
    }
  };
  return createElement(Form.Check, {
    type: 'switch',
    className: (props.className ? props.className : "") + " mn-0",
    label: props.label,
    checked: checked,
    disabled: props.disabled == true ? true : false,
    inline: props.inline == true ? true : false,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  });
};

var OcdRadio = function OcdRadio(props) {
  var _React$useState = useState(props.value),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _onChange = function onChange(valueChecked) {
    if (valueChecked) {
      setValue(valueChecked);
      if (props.onChangeValue) {
        props.onChangeValue(valueChecked);
      }
    }
  };
  var FormRadio = function FormRadio() {
    var time = new Date().getTime().toString();
    var formRadio = [];
    var _loop = function _loop(i) {
      formRadio.push(createElement(Form.Check, {
        key: i,
        inline: props.inline,
        disabled: props.disabled == true ? true : false,
        className: props.className ? props.className : "",
        type: 'radio',
        label: props.options[i].label,
        checked: value == props.options[i].value,
        onChange: function onChange() {
          return _onChange(props.options[i].value);
        },
        name: "inline-radio-" + time
      }));
    };
    for (var i = 0; i < props.options.length; i++) {
      _loop(i);
    }
    return formRadio;
  };
  return createElement(FormRadio, null);
};

var OcdLabel = function OcdLabel(props) {
  return createElement(Form.Label, null, props.text);
};

var OcdButton = function OcdButton(props) {
  var _React$useState = useState(false),
    delayClick = _React$useState[0],
    setDelayClick = _React$useState[1];
  var buttonType = function buttonType() {
    if (props.type == "default" && !props.isOutline) {
      return "dark";
    }
    return props.type;
  };
  return createElement(Button, {
    disabled: delayClick,
    onClick: function onClick() {
      if (props.onClick) {
        props.onClick();
      }
      setDelayClick(true);
      setTimeout(function () {
        setDelayClick(false);
      }, 1000);
    },
    variant: (props.isOutline == true ? "falcon-" : "") + buttonType(),
    className: !props.size || props.size == "sm" ? "btn-sm" : ""
  }, props.icon, ' ', props.label);
};

var OcdButtonList = function OcdButtonList(props) {
  var ButtonList = function ButtonList() {
    var buttons = [];
    for (var i = 0; i < props.buttons.length; i++) {
      buttons.push(createElement(Fragment$1, {
        key: "ele_" + i
      }, createElement(OcdButton, {
        key: "btn_" + i,
        label: props.buttons[i].label,
        type: props.buttons[i].type,
        size: !props.size || props.size == "sm" ? "sm" : "lg",
        onClick: function onClick() {}
      }), ' '));
    }
    return buttons;
  };
  return createElement(ButtonList, null);
};

var OcdToast = forwardRef(function (props, ref) {
  var _React$useState = useState(false),
    show = _React$useState[0],
    setShow = _React$useState[1];
  var _React$useState2 = useState({
      type: "",
      message: ""
    }),
    toast = _React$useState2[0],
    setToast = _React$useState2[1];
  useImperativeHandle(ref, function () {
    return {
      show: function show(type, message) {
        setToast({
          type: type,
          message: message
        });
        setShow(true);
      }
    };
  });
  var ToastTitle = function ToastTitle() {
    if (toast.type == "success") {
      return "Thành công";
    } else if (toast.type == "info") {
      return "Thông tin";
    } else if (toast.type == "warning") {
      return "Cảnh báo";
    } else if (toast.type == "danger") {
      return "Lỗi";
    }
    return "";
  };
  return createElement("div", {
    className: "position-fixed top-0 end-0 p-3",
    style: {
      zIndex: show ? 10000 : 1
    }
  }, createElement(Toast, {
    onClose: function onClose() {
      return setShow(false);
    },
    show: show,
    delay: 3000,
    autohide: props.autohide == true ? true : false
  }, createElement(Toast.Header, {
    className: 'bg-' + toast.type + ' text-white'
  }, createElement("strong", {
    className: "me-auto"
  }, ToastTitle())), createElement(Toast.Body, null, createElement("b", null, toast.message))));
});

var OcdSnipper = function OcdSnipper(props) {
  return createElement(Spinner, {
    size: "sm",
    animation: props.animation,
    variant: props.type
  });
};

var OcdBadge = function OcdBadge(props) {
  return createElement("div", {
    className: classNames("badge badge-soft-" + props.type, {
      'rounded-pill': props.pill
    })
  }, props.label);
};

var OcdModal = forwardRef(function (props, ref) {
  var _React$useState = useState(false),
    modalShow = _React$useState[0],
    setModalShow = _React$useState[1];
  var _React$useState2 = useState(false),
    fullscreen = _React$useState2[0],
    setFullscreen = _React$useState2[1];
  useImperativeHandle(ref, function () {
    return {
      show: function show(modalShow) {
        setModalShow(modalShow);
      }
    };
  });
  return createElement(Modal, {
    show: modalShow,
    fullscreen: fullscreen,
    onHide: function onHide() {
      return setModalShow(false);
    },
    size: props.size,
    "aria-labelledby": "contained-modal-title-vcenter",
    backdrop: "static",
    centered: true
  }, createElement(Modal.Header, null, createElement("div", {
    className: "modal-title h5 mb-0"
  }, props.titleHeader), createElement("div", null, props.fullscreen == true ? fullscreen ? createElement(AiOutlineFullscreenExit, {
    className: "cursor-pointer fs-1",
    style: {
      background: "#e9ecef"
    },
    onClick: function onClick() {
      setFullscreen(false);
    }
  }) : createElement(AiOutlineFullscreen, {
    className: "cursor-pointer fs-1",
    style: {
      background: "#e9ecef"
    },
    onClick: function onClick() {
      setFullscreen(true);
    }
  }) : createElement(Fragment$1, null), ' ', createElement(AiOutlineClose, {
    className: "cursor-pointer fs-1",
    style: {
      background: "#e9ecef"
    },
    onClick: function onClick() {
      setModalShow(false);
    }
  }))), createElement(Modal.Body, null, props.contentBody), createElement(Modal.Footer, null, props.actionFooter, createElement(OcdButton, {
    label: "\u0110\xF3ng",
    isOutline: true,
    type: "default",
    onClick: function onClick() {
      setModalShow(false);
    }
  })));
});

var OcdDropdownButton = function OcdDropdownButton(props) {
  var DropdownItems = function DropdownItems() {
    var items = [];
    var _loop = function _loop(i) {
      if (props.items[i]) {
        items.push(createElement(Dropdown.Item, {
          key: i,
          onClick: function onClick() {
            props.onClick(props.items[i].code);
          },
          disabled: props.items[i].disabled == true ? true : false
        }, props.items[i].name));
      } else {
        items.push(createElement(Dropdown.Divider, {
          key: i
        }));
      }
    };
    for (var i = 0; i < props.items.length; i++) {
      _loop(i);
    }
    return items;
  };
  return createElement(DropdownButton, {
    as: ButtonGroup,
    variant: props.type,
    size: props.size ? props.size : "sm",
    title: props.title
  }, createElement(DropdownItems, null));
};

var OcdTexteditor = function OcdTexteditor(props) {
  var _React$useState = useState(function () {
      return props.value;
    }),
    content = _React$useState[0],
    setContent = _React$useState[1];
  var editor = useRef();
  var getSunEditorInstance = function getSunEditorInstance(sunEditor) {
    editor.current = sunEditor;
  };
  useEffect(function () {}, [content]);
  var _onChange = function onChange(newValue) {
    if (newValue == "<p><br></p>") {
      newValue = "";
    }
    setContent(newValue);
    if (props.onChangeValue) {
      props.onChangeValue(newValue);
    }
  };
  return createElement(SunEditor, {
    getSunEditorInstance: getSunEditorInstance,
    setContents: content,
    onChange: function onChange(content) {
      _onChange(content);
    },
    disable: props.disabled == true ? true : false,
    onImageUploadBefore: props.handleImageUploadBefore,
    setOptions: {
      imageGalleryUrl: props.imageGalleryUrl,
      buttonList: [["undo", "redo"], ["font", "fontSize", "formatBlock"], ["paragraphStyle", "blockquote"], ["bold", "underline", "italic", "strike", "subscript", "superscript"], ["fontColor", "hiliteColor", "textStyle"], ["removeFormat"], "/", ["outdent", "indent"], ["align", "horizontalRule", "list", "lineHeight"], ["table", "link", "video", "audio"], ["imageGallery"], ["fullScreen", "showBlocks", "codeView"], ["preview", "print"], ["save", "template"]],
      defaultTag: "",
      minHeight: "100px"
    },
    height: props.height
  });
};

var OcdCard = function OcdCard(props) {
  return createElement("div", {
    className: "card"
  }, createElement("div", {
    className: "card-header py-2 bg-light"
  }, createElement("div", {
    className: "flex-between-center row"
  }, createElement("div", {
    className: "d-flex align-items-center pe-0 col-sm-auto col-4"
  }, createElement("h5", {
    className: "fs-0 mb-0 text-nowrap py-2 py-xl-0"
  }, props.title)), createElement("div", {
    className: "ms-auto text-end ps-0 col-sm-auto col-8"
  }, createElement("div", {
    className: "orders-actions"
  }, props.actions)))), createElement("div", {
    className: "card-body"
  }, props.children));
};

var OcdTab = function OcdTab(props) {
  var _React$useState = useState(props.activeKey),
    key = _React$useState[0],
    setKey = _React$useState[1];
  var TabItems = function TabItems() {
    var html = [];
    var _loop = function _loop(i) {
      html.push(createElement(Tab, {
        key: i,
        eventKey: props.items[i].key,
        onClick: function onClick() {
          if (props.onClick) props.onClick(props.items[i].key);
        },
        title: props.items[i].title,
        className: 'border-bottom border-x p-3'
      }, props.items[i].content));
    };
    for (var i = 0; i < props.items.length; i++) {
      _loop(i);
    }
    return html;
  };
  return createElement(Tabs, {
    id: "controlled-tab-example",
    activeKey: key,
    onSelect: function onSelect(k) {
      return setKey(k);
    }
  }, TabItems());
};

var OcdAccordion = function OcdAccordion(props) {
  var AccordionItems = function AccordionItems() {
    var html = [];
    var _loop = function _loop(i) {
      html.push(createElement(Accordion.Item, {
        key: i,
        eventKey: props.items[i].key,
        onClick: function onClick() {
          if (props.onClick) props.onClick(props.items[i].key);
        }
      }, createElement(Accordion.Header, null, props.items[i].title), createElement(Accordion.Body, null, props.items[i].content)));
    };
    for (var i = 0; i < props.items.length; i++) {
      _loop(i);
    }
    return html;
  };
  return createElement(Accordion, {
    defaultActiveKey: props.activeKey
  }, AccordionItems());
};

var OcdListGroup = function OcdListGroup(props) {
  var ListGroupItems = function ListGroupItems() {
    var html = [];
    var _loop = function _loop(i) {
      html.push(createElement(ListGroup.Item, {
        key: i,
        action: true,
        href: "#" + props.items[i].key,
        onClick: function onClick() {
          if (props.onClick) props.onClick(props.items[i].key);
        }
      }, props.items[i].content));
    };
    for (var i = 0; i < props.items.length; i++) {
      _loop(i);
    }
    return html;
  };
  return createElement(ListGroup, {
    defaultActiveKey: "#" + props.activeKey
  }, ListGroupItems());
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var OcdTreeviewListItem = function OcdTreeviewListItem(_ref) {
  var item = _ref.item,
    openedItems = _ref.openedItems,
    setOpenedItems = _ref.setOpenedItems,
    selectedItems = _ref.selectedItems,
    setSelectedItems = _ref.setSelectedItems,
    selection = _ref.selection,
    focusItem = _ref.focusItem,
    setFocusItem = _ref.setFocusItem;
  var _useState = useState(openedItems.indexOf(item.id) !== -1),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState([]),
    children = _useState2[0],
    setChildren = _useState2[1];
  var _useState3 = useState([]),
    firstChildren = _useState3[0],
    setFirstChildren = _useState3[1];
  var _useState4 = useState(false),
    childrenOpen = _useState4[0],
    setChildrenOpen = _useState4[1];
  var checkRef = useRef();
  var getChildrens = function getChildrens(item) {
    function flatInnter(item) {
      var flat = [];
      item.map(function (child) {
        if (child.children) {
          flat = [].concat(flat, [child.id], flatInnter(child.children));
        } else {
          flat = [].concat(flat, [child.id]);
        }
      });
      return flat;
    }
    if (item.children) {
      return flatInnter(item.children);
    } else {
      return [];
    }
  };
  var isChildrenOpen = function isChildrenOpen() {
    return openedItems.some(function (item) {
      return firstChildren.indexOf(item) !== -1;
    });
  };
  var handleOnExiting = function handleOnExiting() {
    setOpenedItems(openedItems.filter(function (openedItem) {
      return openedItem !== item.id;
    }));
  };
  var handleEntering = function handleEntering() {
    setOpenedItems([].concat(openedItems, [item.id]));
  };
  var handleSingleCheckboxChange = function handleSingleCheckboxChange(e) {
    if (e.target.checked) {
      setSelectedItems([].concat(selectedItems, [item.id]));
    } else {
      setSelectedItems(selectedItems.filter(function (selectedItem) {
        return selectedItem !== item.id;
      }));
    }
  };
  var handleParentCheckboxChange = function handleParentCheckboxChange(e) {
    var filteredItems = selectedItems.filter(function (selectedItem) {
      return children.indexOf(selectedItem) === -1;
    });
    if (e.target.checked) {
      setSelectedItems([].concat(filteredItems, children));
    } else {
      setSelectedItems(filteredItems);
    }
  };
  useEffect(function () {
    setChildren(getChildrens(item));
    if (item.children) {
      setFirstChildren(item.children.map(function (child) {
        return child.id;
      }));
    }
  }, []);
  useEffect(function () {
    setChildrenOpen(isChildrenOpen());
  }, [children, openedItems]);
  useEffect(function () {
    var childrenSelected = selectedItems.some(function (selectedItem) {
      return children.indexOf(selectedItem) !== -1;
    });
    var allChildrenSelected = children.every(function (child) {
      return selectedItems.indexOf(child) !== -1;
    });
    if (childrenSelected && checkRef.current) {
      checkRef.current.indeterminate = true;
    }
    if (!childrenSelected && checkRef.current) {
      checkRef.current.indeterminate = false;
    }
    if (allChildrenSelected && checkRef.current) {
      checkRef.current.indeterminate = false;
      checkRef.current.checked = true;
    }
    if (!allChildrenSelected && checkRef.current) {
      checkRef.current.checked = false;
    }
  }, [selectedItems, checkRef.current]);
  return React__default.createElement("li", {
    className: "treeview-list-item"
  }, Object.prototype.hasOwnProperty.call(item, 'children') ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: "toggle-container"
  }, selection && React__default.createElement("input", {
    type: "checkbox",
    className: "form-check-input",
    onChange: handleParentCheckboxChange,
    ref: checkRef
  }), React__default.createElement("a", {
    className: classNames('collapse-toggle', {
      collapsed: open || item.expanded
    }),
    href: "#!",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, React__default.createElement("p", {
    className: classNames('treeview-text', {
      'ms-2': !selection
    }) + " " + (item.id == focusItem ? styles["focus-item"] : ""),
    onClick: function onClick() {
      if (setFocusItem) setFocusItem(item.id);
    }
  }, item.name))), React__default.createElement(Collapse, {
    "in": open,
    onExiting: handleOnExiting,
    onEntering: handleEntering
  }, React__default.createElement("ul", {
    className: classNames('treeview-list', {
      'collapse-hidden': !open,
      'collapse-show treeview-border': open,
      'treeview-border-transparent': childrenOpen
    })
  }, item.children.map(function (nestedItem, index) {
    return React__default.createElement(OcdTreeviewListItem, {
      key: index,
      item: nestedItem,
      openedItems: openedItems,
      setOpenedItems: setOpenedItems,
      selectedItems: selectedItems,
      setSelectedItems: setSelectedItems,
      selection: selection,
      focusItem: focusItem,
      setFocusItem: setFocusItem
    });
  })))) : React__default.createElement("div", {
    className: "treeview-item"
  }, selection && React__default.createElement("input", {
    type: "checkbox",
    className: "form-check-input",
    onChange: handleSingleCheckboxChange,
    checked: selectedItems.indexOf(item.id) !== -1
  }), React__default.createElement("a", {
    href: "#!",
    className: "flex-1"
  }, React__default.createElement("p", {
    className: "treeview-text" + " " + (item.id == focusItem ? styles["focus-item"] : ""),
    onClick: function onClick() {
      if (setFocusItem) setFocusItem(item.id);
    }
  }, "\u2002", React__default.createElement(FontAwesomeIcon, {
    icon: item.icon,
    className: classNames('me-2', item.iconClass)
  }), item.name))));
};
var OcdTreeView = function OcdTreeView(_ref2) {
  var data = _ref2.data,
    selection = _ref2.selection,
    _ref2$expanded = _ref2.expanded,
    expanded = _ref2$expanded === void 0 ? [] : _ref2$expanded,
    _ref2$selectedItems = _ref2.selectedItems,
    selectedItems = _ref2$selectedItems === void 0 ? [] : _ref2$selectedItems,
    setSelectedItems = _ref2.setSelectedItems,
    _ref2$focusItem = _ref2.focusItem,
    focusItem = _ref2$focusItem === void 0 ? "" : _ref2$focusItem,
    setFocusItem = _ref2.setFocusItem;
  var _useState5 = useState(expanded),
    openedItems = _useState5[0],
    setOpenedItems = _useState5[1];
  return React__default.createElement("ul", {
    className: "treeview treeview-select"
  }, data.map(function (treeviewItem, index) {
    return React__default.createElement(OcdTreeviewListItem, {
      key: index,
      item: treeviewItem,
      openedItems: openedItems,
      setOpenedItems: setOpenedItems,
      selectedItems: selectedItems,
      setSelectedItems: setSelectedItems,
      selection: selection,
      focusItem: focusItem,
      setFocusItem: setFocusItem
    });
  }));
};
OcdTreeviewListItem.propTypes = {
  item: propTypes.object,
  openedItems: propTypes.array,
  setOpenedItems: propTypes.func,
  selectedItems: propTypes.array,
  setSelectedItems: propTypes.func,
  selection: propTypes.bool,
  focusItem: propTypes.string,
  setFocusItem: propTypes.func
};
OcdTreeView.propTypes = {
  data: propTypes.array.isRequired,
  selection: propTypes.bool,
  expanded: propTypes.array,
  selectedItems: propTypes.array,
  setSelectedItems: propTypes.func,
  focusItem: propTypes.string,
  setFocusItem: propTypes.func
};

var OcdFile = function OcdFile(props) {
  var _React$useState = React__default.useState(props.value),
    files = _React$useState[0],
    setFiles = _React$useState[1];
  var _useDropzone = useDropzone({
      accept: props.accept,
      onDrop: function onDrop(acceptedFiles) {
        var file = {
          Id: v4(),
          Name: "",
          Size: 0,
          DataFile: null
        };
        if (typeof file == "object") {
          file.Name = acceptedFiles[0].path;
          file.Size = acceptedFiles[0].size;
          file.DataFile = acceptedFiles[0];
        }
        var files_temp = [];
        if (props.multiple && files) {
          files_temp = [].concat(files);
        }
        files_temp.push(file);
        setFiles(files_temp);
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  var handleRemove = function handleRemove(id) {
    var files_temp = [].concat(files);
    for (var i = 0; i < files_temp.length; i++) {
      if (files_temp[i].Id == id) {
        files_temp.splice(i, 1);
        break;
      }
    }
    setFiles(files_temp);
  };
  var getSize = function getSize(size) {
    if (size < 1024) {
      return size + " Byte";
    } else if (size < 1024 * 1024) {
      return (size / 1024).toFixed(2) + " KB";
    } else {
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    }
  };
  var previewFile = function previewFile(file) {
    if (typeof file == "object") {
      window.open(URL.createObjectURL(file), '_blank');
    } else if (typeof file == "string") {
      window.open(file, '_blank');
    }
    return false;
  };
  return React__default.createElement("div", null, React__default.createElement("div", Object.assign({}, getRootProps({
    className: 'dropzone-area py-6'
  })), React__default.createElement("input", Object.assign({}, getInputProps())), React__default.createElement("div", {
    className: "d-flex justify-content-center"
  }, React__default.createElement("p", {
    className: "fs-0 mb-0 text-700"
  }, props.placeholder))), React__default.createElement("div", {
    className: "mt-3"
  }, files && files.map(function (file) {
    return React__default.createElement("div", {
      className: "d-flex align-items-center py-3 border-bottom btn-reveal-trigger",
      key: file.Id
    }, React__default.createElement("div", {
      className: "d-flex justify-content-between align-items-center ms-3 flex-1"
    }, React__default.createElement("div", null, React__default.createElement("h6", null, file.Name), React__default.createElement("div", {
      className: "d-flex align-items-center position-relative"
    }, React__default.createElement("p", {
      className: "mb-0 fs--1 text-400 line-height-1"
    }, React__default.createElement("strong", null, getSize(file.Size)))))), React__default.createElement(OcdButton, {
      label: "",
      type: "info",
      isOutline: true,
      icon: React__default.createElement(FontAwesomeIcon, {
        icon: faEye
      }),
      onClick: function onClick() {
        previewFile(file.DataFile);
      }
    }), "\u2002", React__default.createElement(OcdButton, {
      label: "",
      type: "danger",
      isOutline: true,
      icon: React__default.createElement(FontAwesomeIcon, {
        icon: faTrash
      }),
      onClick: function onClick() {
        handleRemove(file.Id);
      }
    }));
  })));
};

var OcdConfirm = React__default.forwardRef(function (props, ref) {
  var modalRef = useRef();
  React__default.useImperativeHandle(ref, function () {
    return {
      show: function show(modalShow) {
        modalRef.current.show(modalShow);
      }
    };
  });
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdModal, {
    size: 'sm',
    titleHeader: "C\u1EA3nh b\xE1o",
    fullscreen: false,
    contentBody: React__default.createElement(React__default.Fragment, null, React__default.createElement(BsExclamationTriangleFill, null), " ", React__default.createElement("b", null, props.content)),
    actionFooter: React__default.createElement(OcdButton, {
      label: "\u0110\u1ED3ng \xFD",
      type: "primary",
      onClick: function onClick() {
        if (props.onClickAccept) {
          props.onClickAccept();
        }
        modalRef.current.show(false);
      }
    }),
    ref: modalRef
  }));
});

var AdvanceTable = function AdvanceTable(_ref) {
  var getTableProps = _ref.getTableProps,
    headers = _ref.headers,
    page = _ref.page,
    prepareRow = _ref.prepareRow,
    headerClassName = _ref.headerClassName,
    bodyClassName = _ref.bodyClassName,
    rowClassName = _ref.rowClassName,
    tableProps = _ref.tableProps;
  var Thead = function Thead() {
    var ths = [];
    for (var i = 0; i < headers.length; i++) {
      var column = headers[i];
      ths.push( /*#__PURE__*/React__default.createElement("th", _extends({
        key: i,
        className: "text-center"
      }, column.getHeaderProps(column.getSortByToggleProps(column.headerProps)), {
        style: _extends({
          width: column.Width
        }, column.getSortByToggleProps(column.headerProps).style)
      }), column.render('Header'), column.canSort ? column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React__default.createElement("span", {
        className: "sort desc"
      }) : /*#__PURE__*/React__default.createElement("span", {
        className: "sort asc"
      }) : /*#__PURE__*/React__default.createElement("span", {
        className: "sort"
      }) : ''));
    }
    return /*#__PURE__*/React__default.createElement("thead", {
      className: headerClassName
    }, /*#__PURE__*/React__default.createElement("tr", null, ths));
  };
  var Tbody = function Tbody() {
    var trs = [];
    for (var i = 0; i < page.length; i++) {
      var row = page[i];
      prepareRow(row);
      var cells = [];
      for (var j = 0; j < row.cells.length; j++) {
        var cell = row.cells[j];
        var align = "";
        for (var x = 0; x < headers.length; x++) {
          if (headers[x].Header == cell.column.Header) {
            align = headers[x].Align;
            break;
          }
        }
        cells.push( /*#__PURE__*/React__default.createElement("td", _extends({
          key: j,
          className: (align ? "text-" + align : "") + " fw-medium"
        }, cell.getCellProps(cell.column.cellProps)), cell.render('Cell')));
      }
      trs.push( /*#__PURE__*/React__default.createElement("tr", _extends({
        key: i,
        className: rowClassName
      }, row.getRowProps()), cells));
    }
    return /*#__PURE__*/React__default.createElement("tbody", {
      className: bodyClassName
    }, trs);
  };
  return /*#__PURE__*/React__default.createElement(SimpleBarReact, null, /*#__PURE__*/React__default.createElement(Table, getTableProps(tableProps), /*#__PURE__*/React__default.createElement(Thead, null), /*#__PURE__*/React__default.createElement(Tbody, null)));
};
AdvanceTable.propTypes = {
  getTableProps: propTypes.func,
  headers: propTypes.array,
  page: propTypes.array,
  prepareRow: propTypes.func,
  headerClassName: propTypes.string,
  bodyClassName: propTypes.string,
  rowClassName: propTypes.string,
  tableProps: propTypes.object
};

var AdvanceTableSearchBox = function AdvanceTableSearchBox(_ref) {
  var globalFilter = _ref.globalFilter,
    setGlobalFilter = _ref.setGlobalFilter,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Tìm kiếm...' : _ref$placeholder,
    className = _ref.className;
  var _useState = useState(globalFilter),
    value = _useState[0],
    setValue = _useState[1];
  var _onChange = useAsyncDebounce(function (value) {
    setGlobalFilter(value || undefined);
  }, 200);
  return /*#__PURE__*/React__default.createElement(InputGroup, {
    className: classNames(className, 'position-relative')
  }, /*#__PURE__*/React__default.createElement(FormControl, {
    value: value || '',
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      setValue(value);
      _onChange(value);
    },
    size: "sm",
    id: "search",
    placeholder: placeholder,
    type: "search",
    className: "shadow-none"
  }), /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    variant: "outline-secondary",
    className: "border-300 hover-border-secondary"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: "search",
    className: "fs--1"
  })));
};

var _excluded = ["indeterminate", "className"];
var IndeterminateCheckbox = React__default.forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var defaultRef = React__default.useRef();
  var resolvedRef = ref || defaultRef;
  React__default.useEffect(function () {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return /*#__PURE__*/React__default.createElement(Form.Check, {
    type: "checkbox",
    className: classNames('fs-0 mb-0', className)
  }, /*#__PURE__*/React__default.createElement(Form.Check.Input, _extends({
    type: "checkbox",
    ref: resolvedRef
  }, rest)));
});
var AdvanceTableWrapper = function AdvanceTableWrapper(_ref2) {
  var children = _ref2.children,
    columns = _ref2.columns,
    data = _ref2.data,
    sortable = _ref2.sortable,
    selection = _ref2.selection,
    selectionColumnWidth = _ref2.selectionColumnWidth,
    pagination = _ref2.pagination,
    _ref2$perPage = _ref2.perPage,
    perPage = _ref2$perPage === void 0 ? 10 : _ref2$perPage,
    setSelectedRows = _ref2.setSelectedRows,
    _ref2$onClickInfo = _ref2.onClickInfo,
    onClickInfo = _ref2$onClickInfo === void 0 ? null : _ref2$onClickInfo,
    _ref2$onClickUpdate = _ref2.onClickUpdate,
    onClickUpdate = _ref2$onClickUpdate === void 0 ? null : _ref2$onClickUpdate,
    _ref2$onClickRemove = _ref2.onClickRemove,
    onClickRemove = _ref2$onClickRemove === void 0 ? null : _ref2$onClickRemove;
  var SortBy = function SortBy() {
    var result = [];
    for (var i = 0; i < columns.length; i++) {
      if (columns[i].hasOwnProperty('Sort')) {
        var desc = null;
        if (columns[i].Sort == "asc") {
          desc = true;
        } else if (columns[i].Sort == "desc") {
          desc = false;
        }
        if (desc != null) {
          result.push({
            id: columns[i].accessor,
            desc: desc
          });
        }
      }
    }
    return result;
  };
  var _useTable = useTable({
      columns: columns,
      data: data,
      disableSortBy: !sortable,
      initialState: {
        pageSize: pagination ? perPage : data.length,
        sortBy: SortBy()
      }
    }, useGlobalFilter, useSortBy, usePagination, useRowSelect, function (hooks) {
      if (selection) {
        hooks.visibleColumns.push(function (columns) {
          return [{
            id: 'selection',
            Header: function Header(_ref3) {
              var getToggleAllRowsSelectedProps = _ref3.getToggleAllRowsSelectedProps;
              return /*#__PURE__*/React__default.createElement(IndeterminateCheckbox, getToggleAllRowsSelectedProps());
            },
            headerProps: {
              style: {
                width: selectionColumnWidth
              }
            },
            cellProps: {
              style: {
                width: selectionColumnWidth
              }
            },
            Cell: function Cell(_ref4) {
              var row = _ref4.row;
              return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IndeterminateCheckbox, row.getToggleRowSelectedProps()));
            }
          }].concat(columns);
        });
      }
      if (onClickUpdate || onClickRemove) {
        hooks.visibleColumns.push(function (columns) {
          return [].concat(columns, [{
            id: 'actions',
            Header: function Header() {
              return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
            },
            headerProps: {
              style: {
                width: selectionColumnWidth
              }
            },
            cellProps: {
              style: {
                textAlign: "center",
                width: selectionColumnWidth
              }
            },
            Cell: function Cell(_ref5) {
              _objectDestructuringEmpty(_ref5);
              return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onClickInfo ? /*#__PURE__*/React__default.createElement("button", {
                className: "btn p-0 me-2"
              }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
                icon: "eye",
                className: "text-info",
                onClick: function onClick() {
                  onClickInfo();
                }
              })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), onClickUpdate ? /*#__PURE__*/React__default.createElement("button", {
                className: "btn p-0 me-2"
              }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
                icon: "edit",
                className: "text-primary",
                onClick: function onClick() {
                  onClickUpdate();
                }
              })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), onClickRemove ? /*#__PURE__*/React__default.createElement("button", {
                className: "btn p-0 me-2"
              }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
                icon: "trash-alt",
                className: "text-danger",
                onClick: function onClick() {
                  onClickRemove();
                }
              })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
            }
          }]);
        });
      }
    }),
    getTableProps = _useTable.getTableProps,
    headers = _useTable.headers,
    page = _useTable.page,
    prepareRow = _useTable.prepareRow,
    canPreviousPage = _useTable.canPreviousPage,
    canNextPage = _useTable.canNextPage,
    nextPage = _useTable.nextPage,
    previousPage = _useTable.previousPage,
    setPageSize = _useTable.setPageSize,
    gotoPage = _useTable.gotoPage,
    pageCount = _useTable.pageCount,
    _useTable$state = _useTable.state,
    pageIndex = _useTable$state.pageIndex,
    pageSize = _useTable$state.pageSize,
    selectedRowIds = _useTable$state.selectedRowIds,
    globalFilter = _useTable$state.globalFilter,
    selectedFlatRows = _useTable.selectedFlatRows,
    setGlobalFilter = _useTable.setGlobalFilter;
  useEffect(function () {
    if (setSelectedRows) {
      setSelectedRows(selectedFlatRows);
    }
  }, [selectedFlatRows]);
  var recursiveMap = function recursiveMap(children) {
    return React__default.Children.map(children, function (child) {
      var _child$props;
      if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.children) {
        return React__default.cloneElement(child, {
          children: recursiveMap(child.props.children)
        });
      } else {
        var _child$props2;
        if ((_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.table) {
          return React__default.cloneElement(child, _extends({}, child.props, {
            getTableProps: getTableProps,
            headers: headers,
            page: page,
            prepareRow: prepareRow,
            canPreviousPage: canPreviousPage,
            canNextPage: canNextPage,
            nextPage: nextPage,
            previousPage: previousPage,
            gotoPage: gotoPage,
            pageCount: pageCount,
            pageIndex: pageIndex,
            selectedRowIds: selectedRowIds,
            pageSize: pageSize,
            setPageSize: setPageSize,
            globalFilter: globalFilter,
            setGlobalFilter: setGlobalFilter
          }));
        } else {
          return child;
        }
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, recursiveMap(children));
};

var AdvanceTableFooter = function AdvanceTableFooter(_ref) {
  var page = _ref.page,
    pageSize = _ref.pageSize,
    pageIndex = _ref.pageIndex,
    rowCount = _ref.rowCount,
    setPageSize = _ref.setPageSize,
    canPreviousPage = _ref.canPreviousPage,
    canNextPage = _ref.canNextPage,
    viewAllBtn = _ref.viewAllBtn,
    nextPage = _ref.nextPage,
    previousPage = _ref.previousPage,
    rowInfo = _ref.rowInfo,
    perPage = _ref.perPage,
    rowsPerPageSelection = _ref.rowsPerPageSelection,
    navButtons = _ref.navButtons,
    _ref$rowsPerPageOptio = _ref.rowsPerPageOptions,
    rowsPerPageOptions = _ref$rowsPerPageOptio === void 0 ? [5, 10, 15] : _ref$rowsPerPageOptio;
  var _useState = useState(false),
    isAllVisible = _useState[0],
    setIsAllVisible = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center fs--1"
  }, rowInfo && /*#__PURE__*/React__default.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "me-2"
  }, "T\u1EEB ", pageSize * pageIndex + 1, " \u0111\u1EBFn ", pageSize * pageIndex + page.length, ' ', "c\u1EE7a ", rowCount, " b\u1EA3n ghi"), viewAllBtn && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "me-2"
  }, "\u2014"), /*#__PURE__*/React__default.createElement(Button, {
    variant: "link",
    size: "sm",
    className: "py-2 px-0 fw-semi-bold",
    onClick: function onClick() {
      setIsAllVisible(!isAllVisible);
      setPageSize(isAllVisible ? perPage : rowCount);
    }
  }, "View ", isAllVisible ? 'less' : 'all', /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: "chevron-right",
    className: "ms-1 fs--2"
  })))), rowsPerPageSelection && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
    className: "mb-0 me-1"
  }, "M\u1ED7i trang"), /*#__PURE__*/React__default.createElement(Form.Select, {
    size: "sm",
    className: "w-auto",
    onChange: function onChange(e) {
      return setPageSize(Number(e.target.value));
    },
    defaultValue: pageSize
  }, rowsPerPageOptions.map(function (value) {
    return /*#__PURE__*/React__default.createElement("option", {
      value: value,
      key: value
    }, value);
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "mb-0 ms-1"
  }, "d\xF2ng"))), navButtons && /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    variant: canPreviousPage ? 'primary' : 'light',
    onClick: function onClick() {
      return previousPage();
    },
    className: classNames({
      disabled: !canPreviousPage
    })
  }, "Previous"), /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    variant: canNextPage ? 'primary' : 'light',
    className: classNames('px-4 ms-2', {
      disabled: !canNextPage
    }),
    onClick: function onClick() {
      return nextPage();
    }
  }, "Next")));
};

var AdvanceTablePagination = function AdvanceTablePagination(_ref) {
  var canPreviousPage = _ref.canPreviousPage,
    canNextPage = _ref.canNextPage,
    previousPage = _ref.previousPage,
    nextPage = _ref.nextPage,
    pageCount = _ref.pageCount,
    pageIndex = _ref.pageIndex,
    gotoPage = _ref.gotoPage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex justify-content-end align-items-center"
  }, /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    variant: "falcon-default",
    onClick: function onClick() {
      return previousPage();
    },
    className: classNames({
      disabled: !canPreviousPage
    })
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: "chevron-left"
  })), /*#__PURE__*/React__default.createElement("ul", {
    className: "pagination mb-0 mx-2"
  }, Array.from(Array(pageCount).keys()).map(function (page, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: page,
      className: classNames({
        active: pageIndex === page
      })
    }, /*#__PURE__*/React__default.createElement(Button, {
      size: "sm",
      variant: "falcon-default",
      className: classNames('page', {
        'me-2': index + 1 !== pageCount
      }),
      onClick: function onClick() {
        return gotoPage(page);
      }
    }, page + 1));
  })), /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    variant: "falcon-default",
    onClick: function onClick() {
      return nextPage();
    },
    className: classNames({
      disabled: !canNextPage
    })
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: "chevron-right"
  })));
};

var TestComponent = function TestComponent(_ref, ref) {
  var columns = _ref.columns,
    data = _ref.data,
    _ref$selection = _ref.selection,
    selection = _ref$selection === void 0 ? false : _ref$selection,
    _ref$onClickInfo = _ref.onClickInfo,
    onClickInfo = _ref$onClickInfo === void 0 ? null : _ref$onClickInfo,
    _ref$onClickUpdate = _ref.onClickUpdate,
    onClickUpdate = _ref$onClickUpdate === void 0 ? null : _ref$onClickUpdate,
    _ref$onClickRemove = _ref.onClickRemove,
    onClickRemove = _ref$onClickRemove === void 0 ? null : _ref$onClickRemove;
  var _useState = useState([]),
    selectedRows = _useState[0],
    setSelectedRows = _useState[1];
  React__default.useImperativeHandle(ref, function () {
    return {
      getSelectedRows: function getSelectedRows() {
        return selectedRows;
      }
    };
  });
  function SelectInfo(_ref2) {
    var selectedRowIds = _ref2.selectedRowIds;
    return selection && /*#__PURE__*/React__default.createElement("h5", {
      className: "fs-0 mb-0 text-nowrap py-2 py-xl-0"
    }, Object.keys(selectedRowIds).length > 0 ? 'Đã chọn ' + Object.keys(selectedRowIds).length + ' bản ghi' : 'Đã chọn 0 bản ghi');
  }
  return /*#__PURE__*/React__default.createElement(AdvanceTableWrapper, {
    selectionColumnWidth: 0,
    columns: columns,
    data: data,
    sortable: true,
    selection: selection,
    pagination: true,
    perPage: 5,
    setSelectedRows: setSelectedRows,
    onClickInfo: onClickInfo,
    onClickUpdate: onClickUpdate,
    onClickRemove: onClickRemove
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "flex-end-center mb-3"
  }, /*#__PURE__*/React__default.createElement(Col, {
    lg: 4
  }, /*#__PURE__*/React__default.createElement(AdvanceTableSearchBox, {
    table: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    lg: 8,
    className: "text-end"
  }, /*#__PURE__*/React__default.createElement(SelectInfo, {
    table: true
  }))), /*#__PURE__*/React__default.createElement(AdvanceTable, {
    table: true,
    headerClassName: "bg-200 text-900 text-nowrap align-middle",
    rowClassName: "align-middle white-space-nowrap",
    tableProps: {
      bordered: true,
      hover: true,
      striped: true,
      className: 'table-sm fs--1 mb-0 overflow-hidden'
    }
  }), /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React__default.createElement(AdvanceTableFooter, {
    rowCount: data.length,
    table: true,
    rowInfo: true,
    navButtons: false,
    rowsPerPageSelection: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React__default.createElement(AdvanceTablePagination, {
    table: true
  })))));
};
var OcdTable = forwardRef(TestComponent);

var OcdDynamicForm = forwardRef(function (props, ref) {
  var _useState = useState(props.initValues),
    InitValues = _useState[0],
    setInitValues = _useState[1];
  var _useState2 = useState(0),
    refeshForm = _useState2[0],
    setRefeshForm = _useState2[1];
  var isFirstLoad = useRef(true);
  var isSubmit = useRef(false);
  var _GetValue = function GetValue(accessor) {
    return InitValues[accessor];
  };
  var _SetValue = function SetValue(accessor, value) {
    var _extends2;
    setRefeshForm(new Date().getTime());
    setInitValues(_extends({}, InitValues, (_extends2 = {}, _extends2[accessor] = value, _extends2)));
  };
  var _GetValues = function GetValues() {
    return InitValues;
  };
  var _SetValues = function SetValues(values) {
    setRefeshForm(new Date().getTime());
    setInitValues(_extends({}, values));
  };
  var InvalidControlRender = function InvalidControlRender(Message) {
    return React__default.createElement("p", {
      className: "fs--1 fw-medium invalid-control"
    }, Message);
  };
  var IsValueNullOrEmpty = function IsValueNullOrEmpty(value) {
    if (value === null || value === "" || value === undefined || value.length === 0 || value === "00000000-0000-0000-0000-000000000000") {
      return true;
    }
    return false;
  };
  var RequiredControl = function RequiredControl(required, label, value) {
    return required && IsValueNullOrEmpty(value) ? InvalidControlRender(label + " bắt buộc.") : React__default.createElement(React__default.Fragment, null);
  };
  useImperativeHandle(ref, function () {
    return {
      GetValues: function GetValues() {
        return _GetValues();
      },
      SetValues: function SetValues(values) {
        _SetValues(values);
      },
      GetValue: function GetValue(accessor) {
        return _GetValue(accessor);
      },
      SetValue: function SetValue(accessor, value) {
        _SetValue(accessor, value);
      },
      SubmitForm: function SubmitForm() {
        return _SubmitForm();
      }
    };
  });
  var _SubmitForm = function _SubmitForm() {
    isSubmit.current = true;
    setRefeshForm(new Date().getTime());
    for (var i = 0; i < props.layout.rows.length; i++) {
      var rows = props.layout.rows[i];
      for (var j = 0; j < rows.cols.length; j++) {
        var col = rows.cols[j];
        if (InitValues.hasOwnProperty(col.accessor)) {
          var value = InitValues[col.accessor];
          if (col.Required && IsValueNullOrEmpty(value)) {
            return false;
          }
        }
      }
    }
    return true;
  };
  var InputTextUI = function InputTextUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdInputText, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var InputNumberUI = function InputNumberUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdInputNumber, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdInputPasswordUI = function OcdInputPasswordUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdInputPassword, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdInputTextMixUI = function OcdInputTextMixUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdInputTextMix, {
      disabled: col.Disabled,
      value: value,
      mixType: 'button',
      mixLabel: "Search",
      align: "right",
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      },
      mixClick: function mixClick() {
        OnClick(col.accessor, value);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdTextareaUI = function OcdTextareaUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdTextarea, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdTexteditorUI = function OcdTexteditorUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdTexteditor, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdSelectUI = function OcdSelectUI(col) {
    var value = InitValues[col.accessor];
    var options = [];
    if (col.Options) {
      options = [].concat(col.Options);
    }
    if (props.optionControl) {
      for (var i = 0; i < props.optionControl.length; i++) {
        if (props.optionControl[i].accessor == col.accessor) {
          options = [].concat(props.optionControl[i].options);
          break;
        }
      }
    }
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdSelect, {
      multiple: col.Multiple,
      searchable: col.Searchable,
      clearable: col.Clearable,
      disabled: col.Disabled,
      value: value,
      options: options,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdDatePickerUI = function OcdDatePickerUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdDatePicker, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdDateTimePickerUI = function OcdDateTimePickerUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdDateTimePicker, {
      disabled: col.Disabled,
      value: value,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdTimePickerUI = function OcdTimePickerUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdTimePicker, {
      disabled: col.Disabled,
      value: value,
      timeIntervals: col.TimeIntervals ? col.TimeIntervals : 10,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdCheckboxUI = function OcdCheckboxUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdCheckbox, {
      disabled: col.Disabled,
      checked: value,
      label: col.Label ? col.Label : "",
      onChangeChecked: function onChangeChecked(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdSwitchUI = function OcdSwitchUI(col) {
    var value = InitValues[col.accessor];
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdSwitch, {
      disabled: col.Disabled,
      checked: value,
      label: col.Label ? col.Label : "",
      onChangeChecked: function onChangeChecked(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OcdRadioUI = function OcdRadioUI(col) {
    var value = InitValues[col.accessor];
    var options = [];
    if (col.Options) {
      options = [].concat(col.Options);
    }
    if (props.optionControl) {
      for (var i = 0; i < props.optionControl.length; i++) {
        if (props.optionControl[i].accessor == col.accessor) {
          options = [].concat(props.optionControl[i].options);
          break;
        }
      }
    }
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(OcdRadio, {
      disabled: col.Disabled,
      value: value,
      options: options,
      inline: true,
      onChangeValue: function onChangeValue(newValue) {
        OnChange(col.accessor, newValue);
      }
    }), RequiredControl(col.Required, col.Label, value));
  };
  var OnClick = function OnClick(accessor, value) {
    if (!isFirstLoad.current) {
      if (props.onClick) {
        props.onClick(accessor, value);
      }
    }
    isFirstLoad.current = false;
  };
  var OnChange = function OnChange(accessor, value) {
    if (!isFirstLoad.current) {
      var _extends3;
      setInitValues(_extends({}, InitValues, (_extends3 = {}, _extends3[accessor] = value, _extends3)));
      if (props.onChange && !isSubmit.current) {
        props.onChange(accessor, value);
      }
    }
    isFirstLoad.current = false;
    isSubmit.current = false;
  };
  var ControlUI = function ControlUI(col) {
    switch (col.ControlType) {
      case "InputText":
        return InputTextUI(col);
      case "InputNumber":
        return InputNumberUI(col);
      case "OcdInputPassword":
        return OcdInputPasswordUI(col);
      case "OcdInputTextMix":
        return OcdInputTextMixUI(col);
      case "OcdTextarea":
        return OcdTextareaUI(col);
      case "OcdTexteditor":
        return OcdTexteditorUI(col);
      case "OcdSelect":
        return OcdSelectUI(col);
      case "OcdDatePicker":
        return OcdDatePickerUI(col);
      case "OcdTimePicker":
        return OcdTimePickerUI(col);
      case "OcdDateTimePicker":
        return OcdDateTimePickerUI(col);
      case "OcdCheckbox":
        return OcdCheckboxUI(col);
      case "OcdSwitch":
        return OcdSwitchUI(col);
      case "OcdRadio":
        return OcdRadioUI(col);
      default:
        return React__default.createElement(React__default.Fragment, null);
    }
  };
  var DynamicForm = function DynamicForm() {
    var rowsHtml = [];
    for (var i = 0; i < props.layout.rows.length; i++) {
      var rows = props.layout.rows[i];
      var colsHtml = [];
      for (var j = 0; j < rows.cols.length; j++) {
        var col = rows.cols[j];
        colsHtml.push(React__default.createElement("div", {
          key: j,
          className: "col-sm-" + col.ColSize
        }, col.ControlType == "Empty" ? React__default.createElement(React__default.Fragment, null) : React__default.createElement("div", {
          className: "mb-1 row"
        }, col.LabelSize == 0 ? React__default.createElement(React__default.Fragment, null) : React__default.createElement("label", {
          className: "mb-1 col-sm-" + col.LabelSize
        }, col.Label, col.Required == true ? React__default.createElement("span", {
          className: 'is-required'
        }, "*") : React__default.createElement(React__default.Fragment, null)), col.ControlType == "Label" ? React__default.createElement(React__default.Fragment, null) : React__default.createElement("div", {
          className: "mb-1 col-sm-" + col.ControlSize
        }, ControlUI(col)))));
      }
      rowsHtml.push(React__default.createElement("div", {
        key: i,
        className: "row"
      }, colsHtml));
    }
    return rowsHtml;
  };
  var DynamicFormMemo = useMemo(function () {
    return React__default.createElement(DynamicForm, null);
  }, [refeshForm]);
  return React__default.createElement("div", {
    key: props.code,
    className: 'dynamicForm'
  }, DynamicFormMemo);
});

var SocialAuthButtons = function SocialAuthButtons() {
  return React__default.createElement(Form.Group, {
    className: "mb-0"
  }, React__default.createElement(Row, null, React__default.createElement(Col, {
    sm: 6,
    className: "pe-sm-1"
  }, React__default.createElement(Button, {
    variant: "",
    size: "sm",
    className: "btn-outline-google-plus mt-2 w-100"
  }, React__default.createElement(FontAwesomeIcon, {
    icon: ['fab', 'google-plus-g'],
    transform: "grow-8",
    className: "me-2"
  }), ' ', "google")), React__default.createElement(Col, {
    sm: 6,
    className: "ps-sm-1"
  }, React__default.createElement(Button, {
    variant: "",
    size: "sm",
    className: "btn-outline-facebook mt-2 w-100"
  }, React__default.createElement(FontAwesomeIcon, {
    icon: ['fab', 'facebook-square'],
    transform: "grow-8",
    className: "me-2"
  }), ' ', "facebook"))));
};

var LoginForm = function LoginForm(props) {
  var _useState = useState({
      email: '',
      password: '',
      remember: false
    }),
    formData = _useState[0],
    setFormData = _useState[1];
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    toast.success("Logged in as " + formData.email, {
      theme: 'colored'
    });
  };
  var handleFieldChange = function handleFieldChange(e) {
    var _extends2;
    setFormData(_extends({}, formData, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2)));
  };
  return React__default.createElement(Form, {
    onSubmit: handleSubmit
  }, React__default.createElement(Form.Group, {
    className: "mb-3"
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Email address"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Email address' : '',
    value: formData.email,
    name: "email",
    onChange: handleFieldChange,
    type: "email"
  })), React__default.createElement(Form.Group, {
    className: "mb-3"
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Password"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Password' : '',
    value: formData.password,
    name: "password",
    onChange: handleFieldChange,
    type: "password"
  })), React__default.createElement(Row, {
    className: "justify-content-between align-items-center"
  }, React__default.createElement(Col, {
    xs: "auto"
  }, React__default.createElement(Form.Check, {
    type: "checkbox",
    id: "rememberMe",
    className: "mb-0"
  }, React__default.createElement(Form.Check.Input, {
    type: "checkbox",
    name: "remember",
    checked: formData.remember,
    onChange: function onChange(e) {
      return setFormData(_extends({}, formData, {
        remember: e.target.checked
      }));
    }
  }), React__default.createElement(Form.Check.Label, {
    className: "mb-0 text-700"
  }, "Remember me"))), props.linkForgotPassword ? React__default.createElement(Col, {
    xs: "auto"
  }, React__default.createElement(Link, {
    className: "fs--1 mb-0",
    to: props.linkForgotPassword
  }, "Forgot Password?")) : React__default.createElement(React__default.Fragment, null)), React__default.createElement(Form.Group, null, React__default.createElement(Button, {
    type: "submit",
    color: "primary",
    className: "mt-3 w-100",
    disabled: !formData.email || !formData.password
  }, "Log in")), React__default.createElement("div", {
    className: 'w-100 position-relative text-center mt-4'
  }, React__default.createElement("hr", {
    className: "text-300"
  }), React__default.createElement("div", {
    className: "divider-content-center"
  }, "or log in with")), React__default.createElement(SocialAuthButtons, null));
};

var Login = function Login(props) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: "d-flex justify-content-between align-items-center mb-2"
  }, React__default.createElement("h5", null, "Log in"), props.linkRegister ? React__default.createElement("p", {
    className: "fs--1 text-600 mb-0"
  }, "or ", React__default.createElement(Link, {
    to: props.linkRegister
  }, "Create an account")) : React__default.createElement(React__default.Fragment, null)), React__default.createElement(LoginForm, {
    hasLabel: props.hasLabel == false ? false : true,
    linkForgotPassword: props.linkForgotPassword
  }));
};

var RegistrationForm = function RegistrationForm(props) {
  var _useState = useState({
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      isAccepted: false
    }),
    formData = _useState[0],
    setFormData = _useState[1];
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    toast.success("Successfully registered as " + formData.name, {
      theme: 'colored'
    });
  };
  var handleFieldChange = function handleFieldChange(e) {
    var _extends2;
    setFormData(_extends({}, formData, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2)));
  };
  return React__default.createElement(Form, {
    onSubmit: handleSubmit
  }, React__default.createElement(Form.Group, {
    className: "mb-3"
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Name"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Name' : '',
    value: formData.name,
    name: "name",
    onChange: handleFieldChange,
    type: "text"
  })), React__default.createElement(Form.Group, {
    className: "mb-3"
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Email address"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Email address' : '',
    value: formData.email,
    name: "email",
    onChange: handleFieldChange,
    type: "text"
  })), React__default.createElement(Row, {
    className: "g-2 mb-3"
  }, React__default.createElement(Form.Group, {
    as: Col,
    sm: 6
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Password"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Password' : '',
    value: formData.password,
    name: "password",
    onChange: handleFieldChange,
    type: "password"
  })), React__default.createElement(Form.Group, {
    as: Col,
    sm: 6
  }, props.hasLabel && React__default.createElement(Form.Label, null, "Confirm Password"), React__default.createElement(Form.Control, {
    placeholder: !props.hasLabel ? 'Confirm Password' : '',
    value: formData.confirmPassword,
    name: "confirmPassword",
    onChange: handleFieldChange,
    type: "password"
  }))), React__default.createElement(Form.Group, {
    className: "mb-3"
  }, React__default.createElement(Form.Check, {
    type: "checkbox",
    id: "acceptCheckbox",
    className: "form-check"
  }, React__default.createElement(Form.Check.Input, {
    type: "checkbox",
    name: "isAccepted",
    checked: formData.isAccepted,
    onChange: function onChange(e) {
      return setFormData(_extends({}, formData, {
        isAccepted: e.target.checked
      }));
    }
  }), React__default.createElement(Form.Check.Label, {
    className: "form-label"
  }, "I accept the ", React__default.createElement(Link, {
    to: "#!"
  }, "terms"), " and", ' ', React__default.createElement(Link, {
    to: "#!"
  }, "privacy policy")))), React__default.createElement(Form.Group, {
    className: "mb-4"
  }, React__default.createElement(Button, {
    className: "w-100",
    type: "submit",
    disabled: !formData.name || !formData.email || !formData.password || !formData.confirmPassword || !formData.isAccepted
  }, "Register")), React__default.createElement("div", {
    className: 'w-100 position-relative text-center'
  }, React__default.createElement("hr", {
    className: "text-300"
  }), React__default.createElement("div", {
    className: "divider-content-center"
  }, "or register with")), React__default.createElement(SocialAuthButtons, null));
};

var Registration = function Registration(props) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Row, {
    className: "align-items-center mb-2"
  }, React__default.createElement(Col, null, React__default.createElement("h5", {
    id: "modalLabel"
  }, "Register")), props.linkLogin ? React__default.createElement(Col, {
    xs: "auto"
  }, React__default.createElement("p", {
    className: "fs--1 text-600 mb-0"
  }, "Have an account? ", React__default.createElement(Link, {
    to: props.linkLogin
  }, "Login"))) : React__default.createElement(React__default.Fragment, null)), React__default.createElement(RegistrationForm, {
    hasLabel: props.hasLabel == false ? false : true
  }));
};

var Login$1 = function Login(props) {
  return React__default.createElement(Container, {
    fluid: true
  }, React__default.createElement(Row, {
    className: "min-vh-100 bg-100"
  }, React__default.createElement(Col, {
    xs: 6,
    className: "d-none d-lg-block position-relative"
  }, React__default.createElement("div", {
    className: "bg-holder",
    style: {
      backgroundImage: "url(" + props.background + ")",
      backgroundPosition: "50% 20%"
    }
  })), React__default.createElement(Col, {
    sm: 10,
    md: 6,
    className: "px-sm-0 align-self-center mx-auto py-5"
  }, React__default.createElement(Row, {
    className: "g-0 justify-content-center"
  }, React__default.createElement(Col, {
    lg: 9,
    xl: 8,
    className: "col-xxl-6"
  }, React__default.createElement(Card, null, React__default.createElement(Card.Header, {
    className: "bg-shape bg-circle-shape text-center p-2"
  }, React__default.createElement(Link, {
    className: "text-white light font-sans-serif fw-bolder fs-4 z-index-1 position-relative",
    to: "/"
  }, "falcon")), React__default.createElement(Card.Body, {
    className: "p-4"
  }, React__default.createElement(LoginForm, {
    hasLabel: props.hasLabel == false ? false : true,
    linkForgotPassword: props.linkForgotPassword
  }))))))));
};

var Registration$1 = function Registration(props) {
  return React__default.createElement(Container, {
    fluid: true
  }, React__default.createElement(Row, {
    className: "min-vh-100 bg-100"
  }, React__default.createElement(Col, {
    xs: 6,
    className: "d-none d-lg-block position-relative"
  }, React__default.createElement("div", {
    className: "bg-holder",
    style: {
      backgroundImage: "url(" + props.background + ")"
    }
  })), React__default.createElement(Col, {
    sm: 10,
    md: 6,
    className: "px-sm-0 align-self-center mx-auto py-5"
  }, React__default.createElement(Row, {
    className: "g-0 justify-content-center"
  }, React__default.createElement(Col, {
    lg: 9,
    xl: 8,
    className: "col-xxl-6"
  }, React__default.createElement(Card, null, React__default.createElement(Card.Header, {
    className: "bg-shape bg-circle-shape text-center p-2"
  }, React__default.createElement(Link, {
    className: "text-white light font-sans-serif fw-bolder fs-4 z-index-1 position-relative",
    to: "/"
  }, "falcon")), React__default.createElement(Card.Body, {
    className: "p-4"
  }, React__default.createElement(RegistrationForm, {
    hasLabel: props.hasLabel == false ? false : true
  }))))))));
};

export { OcdAccordion, OcdBadge, OcdButton, OcdButtonList, OcdCard, OcdCheckbox, OcdConfirm, OcdDatePicker, OcdDateTimePicker, OcdDropdownButton, OcdDynamicForm, OcdFile, OcdInputNumber, OcdInputPassword, OcdInputText, OcdInputTextMix, OcdLabel, OcdListGroup, Login$1 as OcdLoginAdvance, Login as OcdLoginBasic, OcdModal, OcdRadio, Registration$1 as OcdRegistrationAdvance, Registration as OcdRegistrationBasic, OcdSelect, OcdSnipper, OcdSwitch, OcdTab, OcdTable, OcdTextarea, OcdTexteditor, OcdTimePicker, OcdToast, OcdTreeView };
//# sourceMappingURL=index.modern.js.map
